import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import axiosInstance from './services/axios'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'admin-lte/plugins/fontawesome-free/css/all.min.css'
import 'admin-lte/dist/css/adminlte.min.css'
import 'admin-lte/plugins/jquery/jquery.min.js'
import 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import 'admin-lte/dist/js/adminlte.min.js'
import 'admin-lte/plugins/flag-icon-css/css/flag-icons.min.css'
// import '/admin-lte/dist/css/adminlte.min.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSweetalert2)
Vue.config.productionTip = false
Vue.prototype.$http = axiosInstance;
Vue.prototype.$store = store;
Vue.prototype.$config = store.getters['config/config'];
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // If the route requires authentication
    if (!isAuthenticated && !(localStorage.getItem('authToken'))) {
      // If the user is not authenticated, redirect to login
      next({
        path: '/',
        query: { redirect: to.fullPath }
      });
    } else {
      // If the user is authenticated, allow access
      next();
    }
  } else if (to.path === '/' && isAuthenticated) {
    // If trying to access the login page while already authenticated, redirect to dashboard
    next('/home');
  } else {
    // If no special conditions, proceed to the route
    next();
  }
});

new Vue({
  router,
  store,
  created() {
    // Initial config fetch
    this.$store.dispatch('config/fetchConfig');

    // Start periodic config checks
    this.configInterval = setInterval(async () => {
      await this.$store.dispatch('config/fetchConfig');
      console.log("before expiry code")
      const isExpired = this.$store.getters['config/isSubscriptionExpired'];
      console.log("after expiry code")
      console.log(isExpired)
      console.log("final expiry code")
      if (isExpired && this.$route.path!="/") {
        this.handleLogoutDueToExpiry();
      }
    }, 30000);
  },
  methods: {
    handleLogoutDueToExpiry() {
      this.$store.dispatch('logout');
      localStorage.clear();
      this.$swal.fire({
        icon: 'warning',
        title: 'সফটওয়্যারের মেয়াদ শেষ!',
        text: 'আপনার সফটওয়্যারের মেয়াদ শেষ! দয়া করে রিনিউ করুন।',
        confirmButtonText: 'OK',
      }).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push({ name: 'Login' }); // or { path: '/' }
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.configInterval);
  },
  render: h => h(App),
}).$mount('#app')
